import { getLinearSettings } from "../../helper.ts";
import type { ChartStyleSettings } from "../../../../../../../../../api/types/svTypes.ts";

export function argumentAxisTitle(settings: ChartStyleSettings) {
  return getLinearSettings(settings)?.argumentAxis?.title || "";
}
